// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { cookieStorage } from './cookieStorage';

const SUPABASE_URL = "https://vfzylxbiueotpcrifngp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmenlseGJpdWVvdHBjcmlmbmdwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwMjI4MTcsImV4cCI6MjA3MDU5ODgxN30.z0BlMXLnt-pInITnaA9tkLxlnfxGA--46PBGvUQhfMU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: cookieStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
